import DashboardCard, { EmptyState } from './DashboardCard';
import CardGrid from './CardGrid';
import { CARD_FILL_MIN_WIDTH, cardDateColumn, type CardColumn } from './cardColumns';
import type { DashboardAdmittedResident } from '../../types/dashboard';
import { useDashboardNav } from './useDashboardNav';

const columns: CardColumn<DashboardAdmittedResident>[] = [
  { dataField: 'fullName', caption: 'Name', sizing: 'fill' },
  { dataField: 'dietOrder', caption: 'Diet Order', sizing: 'fill', minWidth: CARD_FILL_MIN_WIDTH },
  cardDateColumn<DashboardAdmittedResident>('admitDate', 'Admitted Date', { sortOrder: 'desc' }),
];

interface Props {
  data: DashboardAdmittedResident[];
  draggable?: boolean;
  onDragStart?: (e: React.DragEvent) => void;
  onDragOver?: (e: React.DragEvent) => void;
  onDrop?: (e: React.DragEvent) => void;
  onDragEnd?: () => void;
}

export default function AdmittedGuestsCard({ data, ...dragProps }: Props) {
  const { guestLinkProps } = useDashboardNav();
  return (
    <DashboardCard icon="bi-people" title="Guests" count={data.length} {...dragProps}>
      {data.length === 0 ? (
        <EmptyState message="No guests" />
      ) : (
        <CardGrid<DashboardAdmittedResident>
          {...guestLinkProps<DashboardAdmittedResident>((r) => r.pKey_Patient)}
          ariaLabel="Guests"
          dataSource={data}
          columns={columns}
          keyExpr="pKey_Patient"
        />
      )}
    </DashboardCard>
  );
}
